// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"94e9a786","619":"4669d11c"}[chunkId] + ".chunk.js";
};